export const policyCancellationRefundEligibility = [
  {
    value: 'eligible_for_refund',
    label: 'POLICY_CANCELLATION.refundEligibility.options.eligibleForRefund',
  },
  {
    value: 'eligible_redirected_reused',
    label:
      'POLICY_CANCELLATION.refundEligibility.options.eligibleRedirectedReused',
  },
  {
    value: 'not_eligible_duplicate_policy',
    label:
      'POLICY_CANCELLATION.refundEligibility.options.notEligibleDuplicatePolicy',
  },
];
